import React from 'react'

const Footer = () => {
  return (
    <>
        <div className='footr-main mt-4 mx-4 md:mx-10' >

            <div className='footr-wraper   rounded-2xl bg-gray-900   '>

            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 gap-6 py-7">

           
  
            <div className='h-auto w-full   mt-6'> 
            <div className=' ml-10 md:ml-[30%]'> 
                <h1 className='text-[#FBFEFF] text-[12px] font-bold'>HELP</h1>
                <ul className='text-[#FBFEFF] text-[12px]  py-8'>
                    <li className='py-1 cursor-pointer '>Custmor Service</li>
                    <li className='py-1 cursor-pointer'>FAQs</li>
                    <li className='py-1 cursor-pointer'>Nearby Courts</li>
                    
 
                </ul>
            </div>
            </div>

 


            <div className='h-auto w-full  mt-6'> 
 
            <div className=' ml-10 md:ml-[37%] '> 
                <h1 className='text-[#FBFEFF] text-[12px] font-bold'>ABOUT</h1>
                <ul className='text-[#FBFEFF] text-[12px]  py-8'>
                    <li className='py-1 cursor-pointer'>Our History</li>
                    <li className='py-1 cursor-pointer'>Jobs </li>
                    <li className='py-1 cursor-pointer'>Contact Us</li>
   
                </ul>
            </div>
            </div>



            <div className='h-auto w-full   mt-6'> 
            <div className='ml-10 md:ml-[30%] '> 
                <h1 className='text-[#FBFEFF] text-[12px] font-bold'>LEGAL </h1>
                <ul className='text-[#FBFEFF] text-[12px]  py-8'>
                    <li className='py-1 cursor-pointer'>Terms & Conditions</li>
                    <li className='py-1 cursor-pointer'>Privacy & Policy</li>
                    <li className='py-1 cursor-pointer'>Cookie Policy</li>
 
                </ul>
            </div>
            </div>

             
             </div>

                     
             <div className='icons py-2'>
                        <center className=''>
                            <div className='mb-5 '>
                                <center>
                                    <span className=' pt-6 p-4 cursor-pointer'><i class="fa-brands fa-twitter text-blue-400 text-2xl "></i></span> 
                                    <span className=' pt-6 p-4 cursor-pointer'><i class="fa-brands fa-facebook-f text-blue-400 text-2xl"></i></span>  
                                    <span className=' pt-6 p-4 cursor-pointer px-5'><i class="fa-brands fa-instagram text-blue-400 text-2xl"></i></span> 
                                </center>
                            </div>
                        </center>
                    </div>
            

            </div>


        <div className='copyright py-4'>
            <center>
                <h1 className='text-gray-400 text-sm cursor-pointer'>copyright © 2022  <strong className='px-2'>PADELBUDDY </strong>  ︳All Rights Reserved</h1>
            </center>
        </div>

        </div>
    </>
  )
}

export default Footer